export default "__VITE_ASSET__BdUR8BPI__"